import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet'
import Loader from '../../../../../component/common/Loader'
import Topbar from '../../../../PulseSurvey/Topbar';
import SearchInput from '../../../../../component/common/Input/SearchInput';
import DashboardInfoCard from '../../../../../component/common/DashboardInfoCard';
import Table from '../../../../../component/common/Table';
import Pagination from '../../../../../component/common/Pagination/Pagination';
import { Api } from '../../../../../api';
import { errorToast } from '../../../../../utils/helper';

const companyBadges = [
    { id: 1, name: "Bronze", profilePic: "https://static.whatsapp.net/rsrc.php/v4/y6/r/wa669aeJeom.png" },
    { id: 2, name: "Silver", profilePic: "https://static.whatsapp.net/rsrc.php/v4/y6/r/wa669aeJeom.png" },
]

const ViewB2BDetails = () => {
    const [loader, setLoader] = useState(false);
    const userData = JSON.parse(localStorage.getItem('userData'));
    const [searchTerm, setSearchTerm] = useState('');
    const [debounceTimeout, setDebounceTimeout] = useState(null);
    const { id } = useParams();
    // const redirectUrl = '/dasfa';
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [companiUsersList, setCompanyUsersList] = useState([]);
    const [clickedRowId, setClickedRowId] = useState(null);
    const [clickedCompanyBadges, setClickedCompanyBadges] = useState([]);

    const handleShowBadge = (rowData) => {
        setClickedRowId(rowData?._id);
        setClickedCompanyBadges(rowData?.badges);
        console.log("badges data:", rowData);
    }

    const columns = [
        {
            title: 'Name',
            key: 'name',
            sortable: false,
            align: 'left',
            type: 'profileWithName'
        },
        {
            title: 'Team',
            key: 'teamName',
            sortable: false,
            align: 'left',
            type: 'text3',
        },
        {
            title: 'Badges Won',
            key: 'badgeCount',
            sortable: false,
            align: 'center',
            type: 'text3',
        },
        {
            title: '',
            key: 'action',
            align: 'left',
            // isNavigate: true,
            // navigateUrl: '/user',
            arrowClickFun: handleShowBadge,
            type: 'action',
        }
    ];
    const badgesColumns = [
        {
            title: 'Name',
            key: 'name',
            sortable: false,
            align: 'left',
            type: 'profileWithName'
        },
    ];
    const fetchData = async (page) => {
        setLoader(true);
        const response = await Api.getB2BCompanyById(userData?.userType === 3 ? userData?.id : id, page, searchTerm);
        console.log("response-333", response)
        if (response?.data?.status === "success") {
            setCompanyUsersList(response?.data?.data);
            setTotalCount(response?.data?.total);
            setLoader(false);
        } else if (response?.status === 401) {
            setLoader(false);
            errorToast(response?.message);
        } else if (response?.status === 0) {
            setCurrentPage(1);
            setTotalCount(0);
            setCompanyUsersList([]);
            setLoader(false);
            errorToast(response?.message);
        } else {
            setLoader(false);
        }
    }

    useEffect(() => {
        if (debounceTimeout) clearTimeout(debounceTimeout);
        const timeout = setTimeout(() => {
            fetchData(currentPage)
        }, 500);
        setDebounceTimeout(timeout);
    }, [searchTerm])

    useEffect(() => {
        fetchData(currentPage)
    }, [currentPage])

    const deleteHandler = (id) => { }

    return (
        <div className="relative lg:pl-5 lg:mb-[45px]">
            <Helmet>
                <meta charSet="utf-8" />
                <title>Badges | Shoorah Admin</title>
            </Helmet>
            {loader ? <Loader /> : null}
            <Topbar title={'Badges'} />
            {/* <Breadcrumb pageList={pages} className="lg:mt-8" /> */}

            <div className="sm:flex flex-col md:flex-row justify-between items-center gap-3 mt-3">
                {/* Left-aligned search input */}
                <div className="flex items-center justify-center w-full sm:w-auto">
                    <SearchInput
                        id="searchKey"
                        name="searchKey"
                        type="text"
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            // Debouncing search input
                            if (debounceTimeout) clearTimeout(debounceTimeout);
                            const timeout = setTimeout(() => {
                                // handlePagination(1, selectedPerPage?.value, e.target.value, sortBy, sortOrder);
                            }, 500);
                            setDebounceTimeout(timeout);
                        }}
                        placeholder="Search"
                        className="w-full sm:w-auto px-3 py-2"
                    />
                </div>
            </div>
            <div className="grid grid-cols-12 mt-5 gap-4">
                <div className={`col-span-12 ${clickedCompanyBadges?.length > 0 && 'md:col-span-9'}`}>
                    <Table
                        columns={columns}
                        data={companiUsersList}
                        setDeleteId={deleteHandler}
                        name={'commpany_users'}
                        // addNewURL={redirectUrl}
                        bottomBorder={totalCount > 10}
                        loader={loader}
                        setSearchTerm={(data) => setSearchTerm(data)}
                        activeRowId={clickedRowId}
                    />
                </div>
                {clickedCompanyBadges?.length > 0 && <div className="col-span-12 md:col-span-3 h-full">
                    <Table
                        columns={badgesColumns}
                        data={companyBadges}
                        setDeleteId={deleteHandler}
                        name={'company_badges'}
                        // addNewURL={redirectUrl}
                        bottomBorder={totalCount > 10}
                        // setSortBy={(sort) => handleSortBy(sort)}
                        loader={loader}
                        setSearchTerm={(data) => setSearchTerm(data)}
                    // minHeight='500px'
                    />
                </div>}
            </div>
            <div>
                {companiUsersList?.length > 0 && !loader ? (
                    <Pagination
                        currentPage={currentPage}
                        totalCount={totalCount}
                        pageSize={10}
                        onPageChange={(page) => setCurrentPage(page)}
                    />
                ) : (
                    <span />
                )}
            </div>
        </div>
    )
}

export default ViewB2BDetails